// extracted by mini-css-extract-plugin
module.exports = {"search-allign":"styles_search-allign__8Ceiu","search-Icon":"styles_search-Icon__3dbkG","input-icon-clear":"styles_input-icon-clear__2Ubp-"};